module.exports = __webpack_public_path__ + "img/StarLogo.b5bb4ed5.webp";